import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, Teleport as _Teleport, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tir-pm-text-editor-file-preview" }
const _hoisted_2 = { class: "tir-pm-text-editor-file-preview__top-line tir-pm-text-editor-file-preview-top-line" }
const _hoisted_3 = { class: "tir-pm-text-editor-file-preview-top-line__name-sign" }
const _hoisted_4 = {
  key: 0,
  class: "tir-pm-text-editor-file-preview-top-line__top-settings"
}
const _hoisted_5 = { class: "tir-pm-text-editor-file-preview-content" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import {
  PencilSquareIcon,
  ArrowDownIcon,
} from "tir-style-system/icons/outline";
import { nextTick, watch } from "vue";
import { computed, onMounted, ref } from "vue";
import { PropType } from "vue";
import { ITextEditorFile } from "./interfaces";
import { useEditorWidgets } from "./composables";

/**События компонента */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmTextEditorFilePreview',
  props: {
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Текст поля ввода */
  content: { type: String as PropType<string>, default: "" },
  /**Лейбл над основным инпутом редактора */
  label: { default: "", type: String as PropType<string> },
  /* Высота для редактора */
  height: { type: String as PropType<string>, default: "321" },
  /* Раскрыто ли полностью описание */
  isExpand: { type: Boolean as PropType<boolean>, default: false },
  /**Все файлы */
  allFiles: { type: Array as PropType<Array<T>>, default: [] },
  /**Загрузка при редактировании названия */
  filesLoadingEditName: {
    type: Array as PropType<Array<T["FileId"]>>,
    default: [],
  },
},
  emits: ["toEdit", "changeExpand", "onClickDeleteFile", "onClickEditFile", "saveFileName"],
  setup(__props, { emit }) {

const props = __props;





/** Индикатор expand-кнопки */
const isExpandContent = computed(() => props.isExpand);

/**Отрендерить ли телепорты */
const isRenderTeleport = ref(false);
/**Внутреннее состояние контента */
const innerContent = ref(props.content);
/**Обновить внутренне состояние контента */
const updateInnerContent = async (value: string) => {
  isRenderTeleport.value = false;
  innerContent.value = value;
  await nextTick();
  isRenderTeleport.value = true;
};
watch(
  () => props.content,
  () => updateInnerContent(props.content)
);
watch(
  () => isExpandContent.value,
  () => {
    calculateInnerHeightContent();
  }
);

/**Список виджетов */
const { widgets } = useEditorWidgets({
  content: computed(() => props.content),
  files: computed(() => props.allFiles),
  filesLoadingEditName: computed(() => props.filesLoadingEditName),
  emit: emit,
});

/** Изменить состояние кнопки раскрытия */
const onChangeExpand = () => {
  emit("changeExpand");
};

const $content = ref<HTMLElement>(null);

/** Нажатие кнопки "К редактированию" */
const onClickToEdit = () => {
  emit("toEdit");
};

/** Индикатор expand-кнопки */
const isShowExpandContentButton = ref(false);

const computedPropsContent = computed(() => props.content);
const computedPropsHeight = computed(() => props.height);

const innerHeightContent = ref(0);
const heightStyle = ref(+computedPropsHeight.value / 16 + "rem");

/**Отобразить анимацию и потом раскрыть описание */

watch(
  () => isExpandContent.value,
  (newValue) => {
    if (newValue) {
      heightStyle.value = `${innerHeightContent.value / 16 + 1}rem`;
      setTimeout(() => (heightStyle.value = `max-content`), 100);
    } else {
      heightStyle.value = `${innerHeightContent.value / 16 + 1}rem`;
      setTimeout(() => {
        heightStyle.value = +computedPropsHeight.value / 16 + "rem";
      });
    }
  },
  { immediate: true }
);

watch(computedPropsContent, () => {
  calculateInnerHeightContent();
});

onMounted(() => {
  isRenderTeleport.value = true;
  calculateInnerHeightContent();
});

function calculateInnerHeightContent() {
  setTimeout(() => {
    innerHeightContent.value = $content.value.offsetHeight;

    isShowExpandContentButton.value =
      innerHeightContent.value > +computedPropsHeight.value;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(props.label), 1),
      (__props.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small,
              title: "К редактированию",
              onClick: onClickToEdit
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(PencilSquareIcon))
              ]),
              _: 1
            }, 8, ["variant", "size"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "tir-pm-text-editor-file-preview-content__container",
        style: _normalizeStyle({ height: heightStyle.value })
      }, [
        _createElementVNode("div", {
          class: "tir-pm-text-editor-file-preview-content__preview",
          ref_key: "$content",
          ref: $content,
          innerHTML: innerContent.value
        }, null, 8, _hoisted_6),
        (isRenderTeleport.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(widgets), (widget) => {
              return (_openBlock(), _createBlock(_Teleport, {
                class: "tir-pm-text-editor-file-preview-content__widget",
                key: widget.DataId,
                to: `.tir-pm-text-editor-file-preview-content__preview [data-widget-id='${widget.DataId}']`
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(widget.Component), _mergeProps(widget.Props, _toHandlers(widget.Listeners)), null, 16))
              ], 8, ["to"]))
            }), 128))
          : _createCommentVNode("", true)
      ], 4),
      (isShowExpandContentButton.value)
        ? (_openBlock(), _createBlock(_unref(TirPmButton), {
            key: 0,
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            size: _unref(TirPmButtonSizeEnum).Small,
            style: {"width":"100%"},
            class: "tir-pm-text-editor-file-preview-content__expand",
            onClick: onChangeExpand
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(ArrowDownIcon), {
                class: _normalizeClass(["tir-pm-text-editor-file-preview-content__expand-arrow", {
              'tir-pm-text-editor-file-preview-content__expand-arrow--expand':
                isExpandContent.value,
            }])
              }, null, 8, ["class"])
            ]),
            default: _withCtx(() => [
              (!isExpandContent.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Показать все"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "Свернуть"))
            ]),
            _: 1
          }, 8, ["variant", "size"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})